import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store'

Vue.use(Router)

const router = new Router({
    mode: 'hash',
    scrollBehavior() {
        return {
            x: 0,
            y: 0
        }
    },
    base: process.env.BASE_URL,
    routes: [
        // ======================
        // Blank Layout
        // ======================    
        {
            path: '',
            component: () => import('./layout/blank/Blank.vue'),
            // ======================
            // Theme routes / pages
            // ======================
            children: [{
                path: '/',
                redirect: '/login',
                meta: { requiresVisitor: true }
            }, {
                path: '/login',
                name: 'Login',
                index: 1,
                component: () => import('./views/authentication/Login.vue'),
                meta: { requiresVisitor: true }
            }, {
                path: '/error404',
                name: 'Error 404',
                index: 2,
                component: () => import('./views/authentication/Error404.vue')
            }]
        },
        {
            // ======================
            // Full Layout
            // ======================
            path: '',
            component: () => import('./layout/full/MainContainer.vue'),
            // ======================
            // Theme routes / pages
            // ======================
            children: [{
                path: '/dashboards/classic-dashboard',
                name: 'Dashboard',
                index: 1,
                meta: {
                    breadcrumb: [{
                        title: 'Dashboards',
                        url: '/dashboards/classic-dashboard'
                    },
                    {
                        title: 'Classic Dashboard',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/dashboards/classic-dashboard/ClassicDashboard.vue')
            }, {
                path: '/master/tandatangan',
                name: 'ttdlist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Tandatangan',
                        url: '/master/tandatangan'
                    },
                    {
                        title: 'Tanda Tangan',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/tandatangan/List.vue')
            },{
                path: '/master/tandatangan/input',
                name: 'ttdinput',
                index: 3,
                meta: {
                    breadcrumb: [{
                        title: 'Tandatangan',
                        url: '/master/tandatangan'
                    },
                    {
                        title: 'Tanda Tangan',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/tandatangan/Input.vue')
            },{
                path: '/master/tandatangan/edit/:ref',
                name: 'ttdedit',
                index: 4,
                meta: {
                    breadcrumb: [{
                        title: 'Tandatangan',
                        url: '/master/tandatangan/edit/:ref'
                    },
                    {
                        title: 'Tanda Tangan',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/tandatangan/Input.vue')
            },{
                path: '/master/rekanan',
                name: 'rekananlist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Rekanan',
                        url: '/master/rekanan'
                    },
                    {
                        title: 'Rekanan',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/rekanan/List.vue')
            },{
                path: '/master/rekanan/input',
                name: 'rekananinput',
                index: 3,
                meta: {
                    breadcrumb: [{
                        title: 'Rekanan',
                        url: '/master/rekanan'
                    },
                    {
                        title: 'Rekanan',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/rekanan/Input.vue')
            },{
                path: '/master/rekanan/edit/:ref',
                name: 'rekananedit',
                index: 4,
                meta: {
                    breadcrumb: [{
                        title: 'Rekanan',
                        url: '/master/rekanan/edit/:ref'
                    },
                    {
                        title: 'Rekanan',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/rekanan/Input.vue')
            },{
                path: '/master/inventory',
                name: 'inventorylist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Inventory',
                        url: '/master/inventory'
                    },
                    {
                        title: 'Inventory',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/inventory/List.vue')
            },{
                path: '/master/inventory/input',
                name: 'inventoryinput',
                index: 3,
                meta: {
                    breadcrumb: [{
                        title: 'Inventory',
                        url: '/master/inventory'
                    },
                    {
                        title: 'Inventory',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/inventory/Input.vue')
            },{
                path: '/master/inventory/edit/:ref',
                name: 'inventoryedit',
                index: 4,
                meta: {
                    breadcrumb: [{
                        title: 'Inventory',
                        url: '/master/inventory/edit/:ref'
                    },
                    {
                        title: 'Inventory',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/inventory/Input.vue')
            },{
                path: '/master/pegawai',
                name: 'pegawailist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Pegawai',
                        url: '/master/pegawai'
                    },
                    {
                        title: 'Pegawai',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/pegawai/List.vue')
            },{
                path: '/master/pegawai/input',
                name: 'pegawaiinput',
                index: 3,
                meta: {
                    breadcrumb: [{
                        title: 'Pegawai',
                        url: '/master/pegawai'
                    },
                    {
                        title: 'Pegawai',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/pegawai/Input.vue')
            },{
                path: '/master/pegawai/edit/:ref',
                name: 'pegawaiedit',
                index: 4,
                meta: {
                    breadcrumb: [{
                        title: 'Pegawai',
                        url: '/master/pegawai/edit/:ref'
                    },
                    {
                        title: 'Inventory',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/pegawai/Input.vue')
            },{
                path: '/master/perkiraan',
                name: 'perkiraanlist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Perkiraan',
                        url: '/master/perkiraan'
                    },
                    {
                        title: 'Perkiraan',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/perkiraan/List.vue')
            },{
                path: '/master/perkiraan/input',
                name: 'perkiraaninput',
                index: 3,
                meta: {
                    breadcrumb: [{
                        title: 'Perkiraan',
                        url: '/master/perkiraan'
                    },
                    {
                        title: 'Perkiraan',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/perkiraan/Input.vue')
            },{
                path: '/master/perkiraan/edit/:ref',
                name: 'perkiraanedit',
                index: 4,
                meta: {
                    breadcrumb: [{
                        title: 'Perkiraan',
                        url: '/master/perkiraan/edit/:ref'
                    },
                    {
                        title: 'Perkiraan',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/perkiraan/Input.vue')
            },{
                path: '/master/role',
                name: 'rolelist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Role',
                        url: '/master/role'
                    },
                    {
                        title: 'Role',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/role/List.vue')
            },{
                path: '/master/role/input',
                name: 'roleinput',
                index: 3,
                meta: {
                    breadcrumb: [{
                        title: 'Role',
                        url: '/master/role'
                    },
                    {
                        title: 'Role',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/role/Input.vue')
            },{
                path: '/master/role/edit/:ref',
                name: 'roleedit',
                index: 4,
                meta: {
                    breadcrumb: [{
                        title: 'Role',
                        url: '/master/role/edit/:ref'
                    },
                    {
                        title: 'Role',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/role/Input.vue')
            },{
                path: '/master/user',
                name: 'userlist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'User',
                        url: '/master/user'
                    },
                    {
                        title: 'User',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/user/List.vue')
            },{
                path: '/master/user/input',
                name: 'userinput',
                index: 3,
                meta: {
                    breadcrumb: [{
                        title: 'User',
                        url: '/master/user'
                    },
                    {
                        title: 'User',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/user/Input.vue')
            },{
                path: '/master/user/:ref',
                name: 'useredit',
                index: 4,
                meta: {
                    breadcrumb: [{
                        title: 'Role',
                        url: '/master/user/edit/:ref'
                    },
                    {
                        title: 'User',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/user/Input.vue')
            },{
                path: '/jurnal/dvud',
                name: 'dvudlist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'DVUD',
                        url: '/jurnal/dvud'
                    },
                    {
                        title: 'Voucher Utang',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/jurnal/dvud/Index.vue')
            },{
                path: '/jurnal/dvud/input',
                name: 'dvudinput',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'DVUD',
                        url: '/jurnal/dvud'
                    },
                    {
                        title: 'Voucher Utang',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/jurnal/dvud/Input.vue')
            },{
                path: '/jurnal/dvud/edit/:ref',
                name: 'dvudedit',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'JU',
                        url: '/jurnal/dvud/edit/:ref'
                    },
                    {
                        title: 'Voucher Utang',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/jurnal/dvud/Input.vue')
            },{
                path: '/jurnal/jbk',
                name: 'jbklist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'JBK',
                        url: '/jurnal/jbk'
                    },
                    {
                        title: 'Jurnal Bayar Kas',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/jurnal/jbk/Index.vue')
            },{
                path: '/jurnal/jbk/input',
                name: 'jbkinput',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'JBK',
                        url: '/jurnal/jbk'
                    },
                    {
                        title: 'Jurnal Bayar Kas',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/jurnal/jbk/Input.vue')
            },{
                path: '/jurnal/jbk/edit/:ref',
                name: 'jbkedit',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'JBK',
                        url: '/jurnal/jbk/edit/:ref'
                    },
                    {
                        title: 'Jurnal Bayar Kas',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/jurnal/jbk/Edit.vue')
            },
            
            
            {
                path: '/jurnal/ju',
                name: 'julist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'JU',
                        url: '/jurnal/ju'
                    },
                    {
                        title: 'Jurnal Umum',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/jurnal/ju/Index.vue')
            },{
                path: '/jurnal/ju/input',
                name: 'juinput',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'JU',
                        url: '/jurnal/ju'
                    },
                    {
                        title: 'Jurnal Umum',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/jurnal/ju/Input.vue')
            },{
                path: '/jurnal/ju/edit/:ref',
                name: 'juedit',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'JU',
                        url: '/jurnal/ju/edit/:ref'
                    },
                    {
                        title: 'Jurnal Umum',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/jurnal/ju/Input.vue')
            },{
                path: '/jurnal/jra',
                name: 'jralist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'JRA',
                        url: '/jurnal/jra'
                    },
                    {
                        title: 'Jurnal Rekening Air',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/jurnal/jra/Index.vue')
            },{
                path: '/jurnal/jra/input',
                name: 'jrainput',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'JRA',
                        url: '/jurnal/jra'
                    },
                    {
                        title: 'Jurnal Rekening Air',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/jurnal/jra/Input.vue')
            },{
                path: '/jurnal/jra/edit/:ref',
                name: 'jraedit',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'JU',
                        url: '/jurnal/jra/edit/:ref'
                    },
                    {
                        title: 'Jurnal Rekening Air',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/jurnal/jra/Input.vue')
            },{
                path: '/jurnal/jpk',
                name: 'jpklist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'JPK',
                        url: '/jurnal/jpk'
                    },
                    {
                        title: 'Jurnal Penerimaan Kas',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/jurnal/jpk/Index.vue')
            },{
                path: '/jurnal/jpk/input',
                name: 'jpkinput',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'JPK',
                        url: '/jurnal/jpk'
                    },
                    {
                        title: 'Jurnal Penerimaan Kas',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/jurnal/jpk/Input.vue')
            },{
                path: '/jurnal/jpk/edit/:ref',
                name: 'jpkedit',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'JU',
                        url: '/jurnal/jpk/edit/:ref'
                    },
                    {
                        title: 'Jurnal Penerimaan Kas',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/jurnal/jpk/Input.vue')
            },{
                path: '/jurnal/jpbik',
                name: 'jpbiklist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'JPBIK',
                        url: '/jurnal/jpbik'
                    },
                    {
                        title: 'Jurnal Pemakaian Persediaan',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/jurnal/jpbik/Index.vue')
            },{
                path: '/jurnal/jpbik/input',
                name: 'jpbikinput',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'JPK',
                        url: '/jurnal/jpbik'
                    },
                    {
                        title: 'Jurnal Pemakaian Persediaan',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/jurnal/jpbik/Input.vue')
            },{
                path: '/jurnal/jpbik/edit/:ref',
                name: 'jpbikedit',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'JU',
                        url: '/jurnal/jpbik/edit/:ref'
                    },
                    {
                        title: 'Jurnal Pemakaian Persediaan',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/jurnal/jpbik/Input.vue')
            },{
                path: '/jurnal/jrna',
                name: 'jrnalist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Jurnal Rekening Non Air',
                        url: '/jurnal/jrna'
                    },
                    {
                        title: 'Jurnal Rekening Non Air',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/jurnal/jrna/Index.vue')
            },{
                path: '/jurnal/jrna/input',
                name: 'jrnainput',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'JPK',
                        url: '/jurnal/jrna'
                    },
                    {
                        title: 'Jurnal Rekening Non Air',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/jurnal/jrna/Input.vue')
            },{
                path: '/jurnal/jrna/edit/:ref',
                name: 'jrnaedit',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'JU',
                        url: '/jurnal/jrna/edit/:ref'
                    },
                    {
                        title: 'Jurnal Rekening Non Air',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/jurnal/jrna/Input.vue')
            },{
                path: '/jurnal/jmkb',
                name: 'jmkblist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Jurnal Mutasi Kas Bank',
                        url: '/jurnal/jmkb'
                    },
                    {
                        title: 'Jurnal Mutasi Kas Bank',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/jurnal/jmkb/Index.vue')
            },{
                path: '/jurnal/jmkb/input',
                name: 'jmkbinput',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'JMKB',
                        url: '/jurnal/jmkb'
                    },
                    {
                        title: 'Jurnal Mutasi Kas Bank',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/jurnal/jmkb/Input.vue')
            },{
                path: '/jurnal/jmkb/edit/:ref',
                name: 'jmkbedit',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'JU',
                        url: '/jurnal/jmkb/edit/:ref'
                    },
                    {
                        title: 'Jurnal Mutasi Kas Bank',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/jurnal/jmkb/Input.vue')
            },{
                path: '/jurnal/aktiva',
                name: 'jraktivalist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Jurnal Aktiva',
                        url: '/jurnal/jrna'
                    },
                    {
                        title: 'Jurnal Aktiva',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/jurnal/aktiva/Index.vue')
            },{
                path: '/jurnal/aktiva/input',
                name: 'jraktivainput',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Jurnal Aktiva',
                        url: '/jurnal/jrna'
                    },
                    {
                        title: 'Jurnal Aktiva',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/jurnal/aktiva/Input.vue')
            },{
                path: '/jurnal/aktiva/edit/:ref',
                name: 'jraktivaedit',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Jurnal Aktiva',
                        url: '/jurnal/aktiva/edit/:ref'
                    },
                    {
                        title: 'Jurnal Aktiva',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/jurnal/aktiva/Input.vue')
            },
            {
                path: '/aktiva/daftar',
                name: 'aktivalist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Daftar Aktiva',
                        url: '/aktiva/daftar'
                    },
                    {
                        title: 'Daftar Aktiva',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/aktiva/AktivaList.vue')
            },{
                path: '/aktiva/input',
                name: 'aktivainput',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Input Aktiva',
                        url: '/aktiva/input'
                    },
                    {
                        title: 'Daftar Aktiva',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/aktiva/AktivaForm.vue')
            },{
                path: '/aktiva/edit/:ref',
                name: 'aktivaedit',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Input Aktiva',
                        url: '/aktiva/edit/:ref'
                    },
                    {
                        title: 'Daftar Aktiva',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/aktiva/AktivaForm.vue')
            },{
                path: '/aktiva/koreksi',
                name: 'koreksiaktivalist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Daftar Aktiva',
                        url: '/aktiva/koreksi'
                    },
                    {
                        title: 'Daftar Aktiva',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/aktiva/KoreksiList.vue')
            },{
                path: '/aktiva/koreksiinput',
                name: 'koreksiaktivainput',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Input Aktiva',
                        url: '/aktiva/input'
                    },
                    {
                        title: 'Daftar Aktiva',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/aktiva/KoreksiForm.vue')
            },{
                path: '/aktiva/susut',
                name: 'aktivasusut',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Penyusutan Aktiva',
                        url: '/aktiva/susut'
                    },
                    {
                        title: 'Penyusutan Aktiva',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/aktiva/SusutList.vue')
            },{
                path: '/aktiva/susutproses',
                name: 'susutproses',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Penyusutan Aktiva',
                        url: '/aktiva/susutproses'
                    },
                    {
                        title: 'Penyusutan Aktiva',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/aktiva/SusutForm.vue')
            },{
                path: '/aktiva/hapus',
                name: 'hapusaktivainput',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Hapus Aktiva',
                        url: '/aktiva/hapus'
                    },
                    {
                        title: 'Hapus Aktiva',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/aktiva/HapusForm.vue')
            },{
                path: '/aktiva/posting',
                name: 'aktivaposting',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Daftar Aktiva',
                        url: '/aktiva/posting'
                    },
                    {
                        title: 'Daftar Aktiva',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/aktiva/JurnalList.vue')
            },{
                path: '/aktiva/posting/input/:ref',
                name: 'aktivapostinginput',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Daftar Aktiva',
                        url: '/aktiva/posting/input/:ref'
                    },
                    {
                        title: 'Daftar Aktiva',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/aktiva/AktivaJurnalForm.vue')
            },{
                path: '/aset/daftar',
                name: 'asetlist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Daftar Aset',
                        url: '/aset/daftar'
                    },
                    {
                        title: 'Daftar Aset',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/aset/AsetList.vue')
            },{
                path: '/aset/hapus',
                name: 'asethapus',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Hapus Aset',
                        url: '/aset/hapus'
                    },
                    {
                        title: 'Hapus Aset',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/aset/KoreksiForm.vue')
            },{
                path: '/inventory/bpb',
                name: 'bpblist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Tambah stok (BPB)',
                        url: '/inventory/bpb'
                    },
                    {
                        title: 'Tambah stok (BPB)',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/inventory/bpb/Index.vue')
            },{
                path: '/inventory/bpb/input',
                name: 'bpbinput',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Tambah stok (BPB)',
                        url: '/inventory/bpb'
                    },
                    {
                        title: 'Tambah stok (BPB)',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/inventory/bpb/Input.vue')
            },{
                path: '/inventory/bpb/edit/:ref',
                name: 'bpbedit',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Tambah stok (BPB)',
                        url: '/inventory/bpb/edit/:ref'
                    },
                    {
                        title: 'Tambah stok (BPB)',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/inventory/bpb/Input.vue')
            },
            {
                path: '/posting/bpb',
                name: 'postingbpblist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Tambah stok (BPB)',
                        url: '/inventory/bpb'
                    },
                    {
                        title: 'Tambah stok (BPB)',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/inventory/bpb/PostingIndex.vue')
            },{
                path: '/posting/bpb/edit/:ref',
                name: 'postingbpbedit',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Posting Tambah stok (BPB)',
                        url: '/inventory/bpb/edit/:ref'
                    },
                    {
                        title: 'Posting Tambah stok (BPB)',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/inventory/bpb/PostingInput.vue')
            },
            {
                path: '/inventory/bpp',
                name: 'bpplist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Perminataan Pemakaian Barang (BPP)',
                        url: '/inventory/bpp'
                    },
                    {
                        title: 'Perminataan Pemakaian Barang (BPP)',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/inventory/bpp/Index.vue')
            },{
                path: '/inventory/bpp/input',
                name: 'bppinput',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Perminataan Pemakaian Barang (BPP)',
                        url: '/inventory/bpb'
                    },
                    {
                        title: 'Perminataan Pemakaian Barang (BPP)',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/inventory/bpp/Input.vue')
            },{
                path: '/inventory/bpp/edit/:ref',
                name: 'bppedit',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Perminataan Pemakaian Barang (BPP)',
                        url: '/inventory/bpp/edit/:ref'
                    },
                    {
                        title: 'Perminataan Pemakaian Barang (BPP)',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/inventory/bpp/Input.vue')
            },

            {
                path: '/posting/bpp',
                name: 'postingbpplist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'POSTING PEMAKAIAN (BPP)',
                        url: '/posting/bpp'
                    },
                    {
                        title: 'POSTING PEMAKAIAN (BPP)',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/inventory/bpp/PostingIndex.vue')
            },{
                path: '/posting/bpp/edit/:ref',
                name: 'postingbppedit',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'POSTING PEMAKAIAN (BPP)',
                        url: '/inventory/bpb/edit/:ref'
                    },
                    {
                        title: 'POSTING PEMAKAIAN (BPP)',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/inventory/bpp/PostingInput.vue')
            },
            
            {
                path: '/posting/stok',
                name: 'repostingstok',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Posting DRD',
                        url: '/posting/drd'
                    },
                    {
                        title: 'Posting DRD',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/posting/stok/Index.vue')
            },
            {
                path: '/posting/drd/',
                name: 'drdinput',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Posting DRD',
                        url: '/posting/drd'
                    },
                    {
                        title: 'Posting DRD',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/posting/drd/Index.vue')
            },{
                path: '/posting/lpp/',
                name: 'lpplist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Posting LPP',
                        url: '/posting/lpp'
                    },
                    {
                        title: 'Posting LPP',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/posting/lpp/Index.vue')
            },
            {
                path: '/posting/lppinput/',
                name: 'lppinput',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Posting LPP',
                        url: '/posting/lppinput'
                    },
                    {
                        title: 'Posting LPP',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/posting/lpp/Input.vue')
            },{
                path: '/anggaran',
                name: 'anggaranlist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Anggaran',
                        url: '/anggaran'
                    },
                    {
                        title: 'Anggaran',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/posting/anggaran/Index.vue')
            },{
                path: '/anggaran/input',
                name: 'anggaraninput',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Anggaran',
                        url: '/anggaran/input'
                    },
                    {
                        title: 'Anggaran',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/posting/anggaran/Input.vue')
            },{
                path: '/anggaran/edit/:ref',
                name: 'anggaranedit',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Anggaran',
                        url: '/anggaran/edit/:ref'
                    },
                    {
                        title: 'Anggaran',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/posting/anggaran/Input.vue')
            },{
                path: '/pindahakun',
                name: 'pindahakun',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Anggaran',
                        url: '/anggaran'
                    },
                    {
                        title: 'Anggaran',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/posting/akunmove/Index.vue')
            },{
                path: '/report/index',
                name: 'report',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Laporan',
                        url: '/report/index'
                    },
                    {
                        title: 'Laporan',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/report/Index.vue')
            },       
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/Error404'
        }
    ]
})

import NProgress from 'nprogress';

function isloggedIn(){
    return store.getters.getLoggedin;
}

/*router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (!isloggedIn()) {
        next({
            name: 'Login'
        })
        } else {
        next()
        }
    } else if (to.matched.some(record => record.meta.requiresVisitor)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (isloggedIn()) {
        next({
            name: 'Dashboard'
        })
        } else {
        next()
        }
    } else {
        next() // make sure to always call next()!
    }
})*/

router.beforeResolve((to, from, next) => {
    // If this isn't an initial page load.
    if (to.name) {
        // Start the route progress bar.
        NProgress.start()
    }
    if (to.matched.some(record => record.meta.requiresAuth)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (!isloggedIn()) {
        next({
            name: 'Login'
        })
        } else {
        next()
        }
    } else if (to.matched.some(record => record.meta.requiresVisitor)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (isloggedIn()) {
        next({
            name: 'Dashboard'
        })
        } else {
        next()
        }
    } 
    next()
})

router.afterEach(() => {
    // Complete the animation of the route progress bar.
    NProgress.done()
})
export default router